/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * 교체정보
 */
export type MaintenanceInfo = {
  /**
   * 기준 정보 (주행거리 || 기준일수)
   */
  baseValue: number;
  type: MaintenanceInfo.type;
  /**
   * * 교체필요 여부 (양호:0 , 권장:1, 필요:2)
   */
  status: MaintenanceInfo.status;
  /**
   * * 안내문구
   */
  message: string;
  /**
   * * 잔여거리 비율 (stdDistance-replaceOdometer) / stdDistance
   */
  remainingAmountRatio: number;
  /**
   * * 잔여거리 (stdDistance - replaceOdometer) || 잔여일수 (stdDays - replacementDate)
   */
  remainingValue: number;
};
export namespace MaintenanceInfo {
  export enum type {
    COMBINED = 'COMBINED',
    DISTANCE = 'DISTANCE',
    DAY = 'DAY',
  }
  /**
   * * 교체필요 여부 (양호:0 , 권장:1, 필요:2)
   */
  export enum status {
    NONE = 'NONE',
    GOOD = 'GOOD',
    RECOMMENDED = 'RECOMMENDED',
    REQUIRED = 'REQUIRED',
  }
}

